import { render, staticRenderFns } from "./MainAbout.vue?vue&type=template&id=a60cb34a&scoped=true&"
import script from "./MainAbout.vue?vue&type=script&lang=js&"
export * from "./MainAbout.vue?vue&type=script&lang=js&"
import style0 from "./MainAbout.vue?vue&type=style&index=0&id=a60cb34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60cb34a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheRadarBadge: require('/web/components/TheRadarBadge.vue').default,TheRadarMonthBadge: require('/web/components/TheRadarMonthBadge.vue').default,TheRadarIsiBadge: require('/web/components/TheRadarIsiBadge.vue').default,TheRadarTopFiftyBadge: require('/web/components/TheRadarTopFiftyBadge.vue').default})
